import {notification} from 'antd';
import {isAxiosError} from 'axios';

export type SubmitErrorOutcome = 'unauthenticated' | 'handled';

export const handleSubmitError = (err: unknown): SubmitErrorOutcome => {
    if (isAxiosError(err) && err.response) {
        const backendMessage = extractBackendMessage(err.response.data);
        const status = err.response.status;
        if (status === 401) {
            notification.error({
                title: 'Authentication required',
                description: backendMessage || 'Please sign in again to dispatch.',
            });
            return 'unauthenticated';
        }
        if (status === 503) {
            notification.error({
                title: 'Service unavailable',
                description: backendMessage || 'Dispatch queue is not accepting requests right now.',
            });
        } else {
            notification.error({
                title: `Unexpected status ${status}`,
                description: backendMessage || 'Could not submit the dispatch request.',
            });
        }
        return 'handled';
    }
    notification.error({
        title: 'Network error',
        description: 'Could not reach the dispatch service. Try again.',
    });
    return 'handled';
};

const extractBackendMessage = (body: unknown): string => {
    if (typeof body === 'string') {
        return body;
    }
    if (body && typeof body === 'object' && 'message' in body) {
        const msg = (body as {message?: unknown}).message;
        if (typeof msg === 'string') {
            return msg;
        }
    }
    return '';
};
